/*
 * @Author:
 * @Description:
 * @Date: 2024-10-18 20:58:51
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-checkout-web/src/api/checkout.js
 */
import http from '@/utils/http';
import { initCardPaymentFields } from '@/utils/tools/cardPaymentBasicForm';

// 原始API函数
export function getOrderInfo(data) {
  data.transactionWebsite = window.document.referrer;
  return http.post('/txn/checkoutDetail', data);
}

/**
 * 【仅用于标准收银台页面】获取订单详情信息
 * 对原始getOrderInfo接口的包装，自动处理卡支付字段初始化
 * 注意：此函数仅供标准收银台页面使用，其他页面请使用getOrderInfo
 * @param {Object} data 请求参数，包含key和country
 * @returns {Promise} 处理后的API响应，data字段会被initCardPaymentFields加工
 */
export function getOrderInfo_checkout(data) {
  return getOrderInfo(data).then(res => {
    if (res.respCode === '20000' && res.data) {
      try {
        res.data = initCardPaymentFields(res.data);
      } catch (e) {
        console.error('初始化卡支付字段失败', e);
      }
    }
    return res;
  });
}

export function getCancelUrl(key) {
  return http.get(`/txn/cancel/${key}`);
}

export function payment(data) {
  return http.post('/txn/confirmPayment', data);
}

export function getStatus(key) {
  return http.get(`/txn/orderDetail/${key}`);
}

/**
 * 获取卡种，账单信息，分期信息
 * @param {*} data {country, cardType, cardNumber}
 * @returns
 */
export function getFieldConfig(data) {
  return http.post('/txn/queryFieldConfig', data);
}

/**
 * 【仅用于标准收银台页面】获取卡种、账单及分期信息
 * 对原始getFieldConfig接口的包装，自动处理卡支付字段初始化
 * 注意：此函数仅供标准收银台页面使用，其他页面请使用getFieldConfig
 * @param {Object} data 请求参数，包含key、cardNumber和country
 * @returns {Promise} 处理后的API响应，data字段会被initCardPaymentFields加工
 */
export function getFieldConfig_checkout(data) {
  return getFieldConfig(data).then(res => {
    if (res.respCode === '20000' && res.data) {
      try {
        res.data = initCardPaymentFields(res.data);
      } catch (e) {
        console.error('初始化卡支付字段失败', e);
      }
    }
    return res;
  });
}

/**
 * 获取分期信息
 * @param {*} data
 * @returns
 */
export function getInstallmentInfo(data) {
  return http.post('/txn/installment', data);
}

/**
 * 获取品牌信息
 * @param {*} key
 * @returns
 */
export function getBrandInfo(key) {
  return http.post(`/txn/brand/${key}`);
}

/**
 * 本地支付信息
 * @param {*} id
 * @returns
 */
export function getLocalPaymentInfo(id) {
  return http.get(`/txn/orderDetail/paymentInfo/${id}`);
}
